module.exports = __webpack_public_path__ + "img/nav-01.2f0f13fd.jpg";